import setAuthCallbacks from 'global/redux/features/auth/authCallbacks'

import routesConfig from 'ets/lib/routes/routesConfig'
import { setUser } from 'ets/redux/features/user/userSlice'
import gotoReportPage from 'ets/lib/gotoReportPage'

setAuthCallbacks({ routesConfig, setUser, gotoReportPage })
